module.exports = __webpack_public_path__ + "media/images/vb company logo_full color_white background_360x62-fdcdf25d9b78e246fc938868a044afe4.png";